import React from 'react';
import PropTypes from 'prop-types';

const PickupPointDetails = ({ name, category, props }) => {
    const value = props[category];
    return (
        name && (
            <li className="item item__grouped">
                <span className="item__label">{name}</span>
                <div className="item__value">
                    <span className="item__new-line" dangerouslySetInnerHTML={{ __html: value.localisation }} />
                    <span className="item__new-line"> {value.city}</span>
                    <br />
                    <span className="item__new-line">{value.phone}</span>
                </div>
            </li>
        )
    );
};

PickupPointDetails.propTypes = {
    name: PropTypes.string,
    category: PropTypes.string,
    props: PropTypes.object,
};

export default PickupPointDetails;
